import { render, staticRenderFns } from "./commonSearchStudents.vue?vue&type=template&id=244fe249&scoped=true"
import script from "./commonSearchStudents.vue?vue&type=script&lang=js"
export * from "./commonSearchStudents.vue?vue&type=script&lang=js"
import style0 from "./commonSearchStudents.vue?vue&type=style&index=0&id=244fe249&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244fe249",
  null
  
)

export default component.exports